import React, {useState} from 'react';
import HorizontalLinearStepper from "./HorizontalLinearStepper";
import NegativeThoughtComponent from "./NegativeThoughtComponent";

const HorizontalStepperContainer = () => {
    const [activeStep, setActiveStep] = useState(0);
    const [steps, setSteps] = useState([
        {
            q_id: '6637d1c1a10c573cd7e24e7c',
            label: 'Your Negative Thought',
            question: 'What negative thought are you struggling with?',
            answer: ''
        },
        {
            q_id: '6637d1eaa10c573cd7e24e7d',
            label: 'Past Experiences',
            question: 'Where does this negative thought come from?',
            description: 'Negative thoughts usually come from our past experiences. What happened in your life that makes you believe this thought?',
            answer: ''
        },
        {
            q_id: '6637d256a10c573cd7e24e7e',
            label: 'Helping a Friend',
            question: 'If your friend was dealing with the same negative thought, what would you say to help them feel more hopeful?',
            description: 'Then, imagine your friend telling you this more hopeful thought.',
            answer: ''
        },
        {
            q_id: '6637d29ea10c573cd7e24e7f',
            label: 'Feeling More Helpful',
            question: 'What do you need to say or do so you can truly believe the more hopeful thought?',
            description: 'What do you need to let go of so you can feel better? What do you need to say to convince yourself or focus on the positive?',
            answer: ''
        },
    ]);


    const handleLeft = () => {
        if(activeStep>0) {
            setActiveStep(activeStep - 1);
        }
    };

    const handleRight = () => {
        if(activeStep+1 < steps.length) {
            setActiveStep(activeStep + 1);
        }
    };

    return (
        <>
            <div style={{display: "flex", justifyContent: "center", marginTop: "30px"}}>
                <NegativeThoughtComponent steps={steps} activeStep={activeStep} handleRight={handleRight} setSteps={setSteps}/>
            </div>
            <div className="stick-to-bottom">
                <HorizontalLinearStepper activeStep={activeStep} setActiveStep={setActiveStep} steps={steps} handleLeft={handleLeft} handleRight={handleRight}/>
            </div>
        </>
)
    ;
};

export default HorizontalStepperContainer;